import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, standardViewport } from '../../utils/animation';
import './ProcessEquipment.scss';


const ProcessEquipment = () => {
  const { t } = useTranslation('process');
  const content = t('equipment.content', { returnObjects: true });
  const features = t('equipment.features', { returnObjects: true });
  
  // Folosim animații centralizate pentru consistență

  return (
    <section className="process-equipment">
      <div className="container">
        <motion.h2
          className="process-equipment__title"
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
          variants={fadeInUp}
        >
          {t('equipment.title')}
        </motion.h2>
        <motion.p
          className="process-equipment__intro"
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
          variants={fadeInUp}
        >
          {t('equipment.intro')}
        </motion.p>
        
        <div className="process-equipment__content">
          <motion.div
            className="process-equipment__text"
            initial="hidden"
            whileInView="visible"
            viewport={standardViewport}
            variants={fadeInUp}
          >
            <p>{content.paragraph1}</p>
            <p>{content.paragraph2}</p>
            <ul>
              {features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </motion.div>
          
          <motion.div
            className="process-equipment__image"
            initial="hidden"
            whileInView="visible"
            viewport={standardViewport}
            variants={fadeInUp}
          >
            <img src="/images/equipment.png" alt="Echipamente de procesare nuci" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProcessEquipment;
